import './WorkloadContainer.scss';
import { Progress } from '@festo-ui/react';
import useTranslation from '../../../../features/translation/hooks/useTranslation';

enum TranslationKeys {
  STROKE = 'utilizationStroke',
  HOUR = 'utilizationHour',
}

interface WorkloadContainerProps {
  utilizationPerStroke: number;
  utilizationPerHour: number;
}

export default function WorkloadContainer({
  utilizationPerHour,
  utilizationPerStroke,
}: WorkloadContainerProps): JSX.Element {
  const t = useTranslation();

  const w = {
    name: t(TranslationKeys.STROKE),
    value: +utilizationPerStroke.toFixed(2),
  };

  const w2 = {
    name: t(TranslationKeys.HOUR),
    value: +utilizationPerHour.toFixed(2),
  };

  return (
    <>
      <div className="ems-workload-container">
        <div key={w.name}>
          <label className="ems-description-key fwe-d-block fwe-pb-2">{t(w.name)}</label>
          <Progress progress={Math.max(w.value)} />
          <p className="ems-workload-value">{w.value} %</p>
        </div>
      </div>
      <div className="ems-workload-container">
        <div key={w2.name}>
          <label className="ems-description-key fwe-d-block fwe-pb-2">{t(w2.name)}</label>
          <Progress progress={Math.max(w2.value)} />
          <p className="ems-workload-value">{w2.value} %</p>
        </div>
      </div>
    </>
  );
}
